<template>
  <div>
    <p class="text-sm text-[#828282] mb-[1rem]">
      Atur jumlah level persetujuan untuk setiap departemen.
    </p>
    <BTable
      :items="divisionItems"
      :fields="divisionFields"
      :busy="isLoading"
      responsive
      show-empty
      empty-text="Tidak ada data yang ditampilkan."
      class="align-middle mb-0 bordered-body-b-table"
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <BSpinner class="align-middle mr-1" />
          <span>Memuat data...</span>
        </div>
      </template>

      <template #cell(division)="data">
        <span class="text-sm font-medium text-black">
          {{ data.item.division }}
        </span>
      </template>

      <template #cell(approver1)="data">
        <div v-if="data.item.approver1 && data.item.approver1 !== '-'">
          <div class="text-sm font-medium text-black">
            {{ data.item.approver1 }}
          </div>
          <div
            v-if="data.item.approver1Role"
            class="text-xs text-[#828282]"
          >
            {{ data.item.approver1Role }}
          </div>
        </div>
        <span
          v-else
          class="text-sm text-black"
        >-</span>
      </template>

      <template #cell(approver2)="data">
        <div v-if="data.item.approver2 && data.item.approver2 !== '-'">
          <div class="text-sm font-medium text-black">
            {{ data.item.approver2 }}
          </div>
          <div
            v-if="data.item.approver2Role"
            class="text-xs text-[#828282]"
          >
            {{ data.item.approver2Role }}
          </div>
        </div>
        <span
          v-else
          class="text-sm text-black"
        >-</span>
      </template>

      <template #cell(approver3)="data">
        <div v-if="data.item.approver3 && data.item.approver3 !== '-'">
          <div class="text-sm font-medium text-black">
            {{ data.item.approver3 }}
          </div>
          <div
            v-if="data.item.approver3Role"
            class="text-xs text-[#828282]"
          >
            {{ data.item.approver3Role }}
          </div>
        </div>
        <span
          v-else
          class="text-sm text-black"
        >-</span>
      </template>

      <template #cell(approver4)="data">
        <div v-if="data.item.approver4 && data.item.approver4 !== '-'">
          <div class="text-sm font-medium text-black">
            {{ data.item.approver4 }}
          </div>
          <div
            v-if="data.item.approver4Role"
            class="text-xs text-[#828282]"
          >
            {{ data.item.approver4Role }}
          </div>
        </div>
        <span
          v-else
          class="text-sm text-black"
        >-</span>
      </template>

      <template #cell(approver5)="data">
        <div v-if="data.item.approver5 && data.item.approver5 !== '-'">
          <div class="text-sm font-medium text-black">
            {{ data.item.approver5 }}
          </div>
          <div
            v-if="data.item.approver5Role"
            class="text-xs text-[#828282]"
          >
            {{ data.item.approver5Role }}
          </div>
        </div>
        <span
          v-else
          class="text-sm text-black"
        >-</span>
      </template>

      <template #cell(approverFinal)="data">
        <div v-if="data.item.approverFinal && data.item.approverFinal !== '-'">
          <div class="text-sm font-medium text-black">
            {{ data.item.approverFinal }}
          </div>
          <div
            v-if="data.item.approverFinalRole"
            class="text-xs text-[#828282]"
          >
            {{ data.item.approverFinalRole }}
          </div>
        </div>
        <span
          v-else
          class="text-sm text-black"
        >-</span>
      </template>

      <template #cell(action)="data">
        <div class="flex items-center gap-[.5rem] justify-end">
          <BButton
            variant="link"
            size="sm"
            class="border !flex items-center gap-[.25rem]"
            @click="handleAturDivision(data.item)"
          >
            <span class="k-edit-2 text-[16px] text-black" />
            <span class="text-xs font-medium text-black">Atur</span>
          </BButton>
        </div>
      </template>
    </BTable>
    <ModalConfirmation :modal="modalConfirm" />
    <DrawerApprovalChainDivision
      :visible="isDrawerVisible"
      :division-data="selectedDivision"
      :is-submitting="isSubmitting"
      @on-close="isDrawerVisible = false"
      @on-save="handleSaveDivision"
      @on-delete="handleDeleteDivision"
    />
  </div>
</template>

<style scoped>
::v-deep .btn-outline-danger,
::v-deep .btn-outline-primary,
::v-deep .btn-link {
  border-radius: 10px !important;
}

::v-deep .bordered-body-b-table tbody {
  box-shadow:
    inset 0 -1px 0 #ddd,
    inset 1px 0 0 #ddd,
    inset -1px 0 0 #ddd;
  border-radius: 0 0 15px 15px;
}
</style>

<script>
import { komtimAxiosIns } from '@/libs/axios'
import ModalConfirmation from '../../components/ModalConfirmation.vue'
import DrawerApprovalChainDivision from './DrawerApprovalChainDivision.vue'
import { confirmModalMessage } from '../../helpers/string-html'
import {
  tableDivisionFields,
  showSuccess,
  showError,
  getGlobalFinalApprover,
  createDivisionConfig,
  updateDivisionConfig,
  deleteDivisionConfig,
} from '../config'

export default {
  name: 'TabApprovalChainDivision',
  components: {
    DrawerApprovalChainDivision,
    ModalConfirmation,
  },
  data() {
    return {
      divisionFields: tableDivisionFields,
      isDrawerVisible: false,
      selectedDivision: {},
      divisionItems: [],
      isLoading: false,
      isSubmitting: false,
      modalConfirm: {
        id: 'modal-confirm-delete-division-config',
        title: '',
        description: '',
        negativeButtonAction: () => {},
        negativeButtonText: '',
        positiveButtonAction: () => {},
        positiveButtonText: '',
        closeButtonAction: () => {},
      },
    }
  },
  mounted() {
    this.fetchDivisionConfigs()
  },
  methods: {
    buildDivisionFields(totalApprover = 2) {
      const fields = [
        {
          key: 'division',
          label: 'Divisi',
          thClass: '!rounded-tl-xl !capitalize !font-medium !text-[14px] !text-black',
          thStyle: {
            textTransform: 'capitalize',
            fontWeight: '500',
            fontSize: '14px',
            color: 'black',
          },
          tdClass: 'text-black font-medium text-[14px]',
        },
      ]

      const nonFinalCount = Math.max(1, totalApprover - 1)
      for (let s = 1; s <= nonFinalCount; s += 1) {
        fields.push({
          key: `approver${s}`,
          label: `Approver ${s}`,
          thClass: '!capitalize !font-medium !text-[14px] !text-black',
          thStyle: {
            textTransform: 'capitalize',
            fontWeight: '500',
            fontSize: '14px',
            color: 'black',
          },
          tdClass: 'text-black font-medium text-[14px]',
        })
      }

      fields.push({
        key: 'approverFinal',
        label: 'Approver Final',
        thClass: '!capitalize !font-medium !text-[14px] !text-black',
        thStyle: {
          textTransform: 'capitalize',
          fontWeight: '500',
          fontSize: '14px',
          color: 'black',
        },
        tdClass: 'text-black font-medium text-[14px]',
      })

      fields.push({
        key: 'action',
        label: 'Aksi',
        class: 'text-right',
        thClass: '!rounded-tr-xl !capitalize !font-medium !text-[14px] !text-black',
        thStyle: {
          textTransform: 'capitalize',
          fontWeight: '500',
          fontSize: '14px',
          color: 'black',
        },
        tdClass: 'text-black font-medium text-[14px]',
      })

      return fields
    },
    async fetchDivisionConfigs() {
      this.isLoading = true
      try {
        const response = await komtimAxiosIns.get('v1/overtime_configurations/divisions')
        const rawData = response?.data?.data
        let rawItems = []
        if (Array.isArray(rawData)) {
          rawItems = rawData
        } else if (Array.isArray(rawData?.items)) {
          rawItems = rawData.items
        }

        const totalApproverFromApi = Number(
          rawData?.total_approver
          || rawData?.total_approvers
          || response?.data?.total_approver
          || 0,
        )

        let maxCount = totalApproverFromApi > 0 ? totalApproverFromApi : 2
        rawItems.forEach(item => {
          const approversList = Array.isArray(item.approvers) ? item.approvers : []
          if (approversList.length > maxCount) {
            maxCount = approversList.length
          }
        })

        this.divisionFields = this.buildDivisionFields(maxCount)

        let globalApprover = null
        try {
          globalApprover = await getGlobalFinalApprover()
        } catch (e) {
          // ignore
        }

        const nonFinalCount = Math.max(1, maxCount - 1)

        this.divisionItems = rawItems.map(item => {
          const approversList = Array.isArray(item.approvers) ? item.approvers : []
          const nonFinalApprovers = approversList.filter(a => !a.is_final)
          const finalStep = approversList.find(a => a.is_final)

          const approverData = {}
          for (let s = 1; s <= nonFinalCount; s += 1) {
            const stepAppr = approversList.find(a => Number(a.step) === s && !a.is_final)
              || nonFinalApprovers[s - 1]
            if (stepAppr) {
              approverData[`approver${s}`] = stepAppr.user_name || stepAppr.name || stepAppr.full_name || '-'
              approverData[`approver${s}Role`] = stepAppr.user_role || stepAppr.role || stepAppr.position_name || ''
              approverData[`approver_${s}_id`] = stepAppr.user_id || stepAppr.id || null
            } else if (s === 1 && (item.approver_1_name || item.approver1_name || item.approver_1)) {
              const a1Name = item.approver_1_name || item.approver1_name || item.approver_1
              approverData.approver1 = a1Name || '-'
              approverData.approver1Role = item.approver_1_role || item.approver1_role || ''
              approverData.approver_1_id = item.approver_1_id || null
            } else {
              approverData[`approver${s}`] = '-'
              approverData[`approver${s}Role`] = ''
              approverData[`approver_${s}_id`] = null
            }
          }

          let approverFinalName = ''
          let approverFinalRole = ''
          let approverFinalId = null

          if (finalStep) {
            approverFinalId = finalStep.user_id || finalStep.id || null
            approverFinalName = finalStep.user_name || finalStep.name || finalStep.full_name || ''
            approverFinalRole = finalStep.user_role || finalStep.role || finalStep.position_name || ''
          }

          if (!approverFinalName && item.approval_final) {
            if (typeof item.approval_final === 'object') {
              approverFinalId = item.approval_final.user_id || item.approval_final.id || null
              approverFinalName = item.approval_final.user_name || item.approval_final.name || item.approval_final.full_name || ''
              approverFinalRole = item.approval_final.user_role || item.approval_final.role || item.approval_final.position_name || ''
            } else if (typeof item.approval_final === 'string') {
              approverFinalName = item.approval_final
            } else if (typeof item.approval_final === 'number') {
              approverFinalId = item.approval_final
            }
          }

          if (!approverFinalName) {
            approverFinalName = item.approver_final_name || item.approverFinal_name || item.approver_final || ''
            approverFinalRole = item.approver_final_role || item.approverFinal_role || ''
            approverFinalId = item.approver_final_id || item.approverFinal_id || approverFinalId
          }

          if (!approverFinalName && globalApprover) {
            approverFinalName = globalApprover.user_name || globalApprover.name || ''
            approverFinalRole = globalApprover.role || ''
            approverFinalId = globalApprover.user_id || globalApprover.id || approverFinalId
          }

          const divisionName = item.division_name || item.name || item.division || '-'
          const divisionId = item.division_id || item.id
          const configId = Number(item.id) > 0 ? Number(item.id) : 0
          const isConfigured = configId > 0 && !!approverData.approver1 && approverData.approver1 !== '-'

          return {
            id: configId,
            config_id: configId,
            division_id: divisionId,
            division: divisionName,
            division_name: divisionName,
            ...approverData,
            approver_final_id: approverFinalId,
            approverFinal: approverFinalName || '-',
            approverFinalRole,
            approvers: approversList,
            approval_final: item.approval_final,
            total_approvals: item.total_approvals || item.total_approver || (isConfigured ? maxCount : 0),
            is_configured: isConfigured,
            created_at: item.created_at,
            updated_at: item.updated_at,
            raw: item,
          }
        })
      } catch (error) {
        showError(error, 'Gagal memuat konfigurasi divisi')
      } finally {
        this.isLoading = false
      }
    },
    handleAturDivision(item) {
      this.selectedDivision = item
      this.isDrawerVisible = true
    },
    async handleSaveDivision({
      divisionData,
      divisionId: propDivisionId,
      levels,
      finalApprover,
      finalApproverId,
    }) {
      const isEdit = Number(divisionData?.id || divisionData?.config_id) > 0
      const configId = isEdit ? Number(divisionData.id || divisionData.config_id) : 0
      this.isSubmitting = true
      try {
        let finalId = finalApproverId
          || finalApprover?.user_id
          || finalApprover?.id
          || divisionData?.approver_final_id
          || divisionData?.approval_final?.user_id
          || divisionData?.approval_final?.id

        if (!finalId) {
          const globalApprover = await getGlobalFinalApprover()
          finalId = globalApprover?.user_id || globalApprover?.id
        }

        if (!finalId) {
          showError(null, 'Approver Final Global belum diatur. Silakan atur Approver Final Global terlebih dahulu.')
          this.isSubmitting = false
          return
        }

        const approversPayload = (levels || [])
          .filter(l => l.approver && (l.approver.id || l.approver.user_id))
          .map((l, idx) => ({
            user_id: Number(l.approver.id || l.approver.user_id),
            step: idx + 1,
            is_final: false,
          }))

        approversPayload.push({
          user_id: Number(finalId),
          step: approversPayload.length + 1,
          is_final: true,
        })

        const divisionId = Number(
          divisionData?.division_id
          || divisionData?.raw?.division_id
          || propDivisionId
          || divisionData?.id,
        )

        const payload = {
          division_id: divisionId,
          approvers: approversPayload,
        }

        try {
          if (configId > 0) {
            await updateDivisionConfig(divisionId, payload)
          } else {
            await createDivisionConfig(payload)
          }
        } catch (err) {
          if (configId > 0 && (err?.response?.status === 404 || err?.response?.status === 405 || err?.response?.data?.meta?.message?.includes('not found'))) {
            await createDivisionConfig(payload)
          } else {
            throw err
          }
        }

        if (isEdit) {
          showSuccess('Perubahan Berhasil Disimpan!')
        } else {
          showSuccess('Data Berhasil Ditambahkan!')
        }

        this.isDrawerVisible = false
        await this.fetchDivisionConfigs()
      } catch (error) {
        if (isEdit) {
          showError(error, 'Gagal Memperbarui Data!')
        } else {
          showError(error, 'Gagal Menambahkan Data!')
        }
      } finally {
        this.isSubmitting = false
      }
    },
    handleDeleteDivision(item) {
      if (!item || (!item.id && !item.division_id)) return
      this.modalConfirm.title = 'Hapus Konfigurasi Approval Lembur?'
      this.modalConfirm.description = confirmModalMessage(
        `Konfigurasi approval lembur untuk divisi <strong>${item.division || item.division_name}</strong> akan dihapus. Apakah Anda ingin melanjutkan?`,
      )
      this.modalConfirm.negativeButtonText = 'Batalkan'
      this.modalConfirm.negativeButtonAction = () => {
        this.$bvModal.hide(this.modalConfirm.id)
      }
      this.modalConfirm.positiveButtonText = 'Ya, Hapus'
      this.modalConfirm.positiveButtonAction = async () => {
        try {
          const targetDivisionId = Number(item.division_id || item.raw?.division_id || item.id)
          await deleteDivisionConfig(targetDivisionId)
          showSuccess('Perubahan Berhasil Disimpan!')
          this.isDrawerVisible = false
          this.$bvModal.hide(this.modalConfirm.id)
          await this.fetchDivisionConfigs()
        } catch (error) {
          showError(error, 'Gagal Memperbarui Data!')
        }
      }
      this.modalConfirm.closeButtonAction = () => {
        this.$bvModal.hide(this.modalConfirm.id)
      }

      this.$bvModal.show(this.modalConfirm.id)
    },
  },
}
</script>
